import { AfterViewInit, Component, EventEmitter, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MVDNowViewService } from './mvdnow-view.service';

@Component({
    selector: 'mvdnow-view',
    templateUrl: './mvdnow-view.html',
    inputs: ['customerNumber'],
    outputs: ['documentSelected', 'messageSelected', 'titleSelected']
})

export class MVDNowViewComponent extends BaseComponent implements AfterViewInit, OnDestroy {
    private customerNumber: number;
    private documentSelected: EventEmitter<number> = new EventEmitter<number>();
    private messageSelected: EventEmitter<number> = new EventEmitter<number>();
    private titleSelected: EventEmitter<number> = new EventEmitter<number>();

    constructor(public viewService: MVDNowViewService) {
        super();
        viewService.customerNumberSubject.next(null);
    }

    ngOnInit() {
        const self = this;

        self.viewService.showDetail();
        self.viewService.documentSelected = () => self.documentSelected.emit(null);
        self.viewService.messageSelected = () => self.messageSelected.emit(null);
        self.viewService.titleSelected = (vehicleId: number) => {
            self.titleSelected.emit(vehicleId);
            self.viewService.showTitle(vehicleId);
        };
    }

    ngAfterViewInit() {
        const self = this;
        self.viewService.customerNumberSubject.next(self.customerNumber);
    }

    ngOnDestroy() {
        const self = this;

        self.viewService.showDetail();
        self.viewService.documentSelected = null;
        self.viewService.messageSelected = null;
        self.viewService.titleSelected = null;
        super.ngOnDestroy();
    }
}
